// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const updateCustomerSearchModalVisibility = visibility =>

    dispatch => {

        dispatch({
            type: actions.UPDATE_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER_MODAL_VISIBILITY,
            visibility
        });

    };



// WEBPACK FOOTER //
// ./src/product/products-by-customer/action-creators/customer-search-modal-visibility.js